import { XYZ as XYZSource } from '../source/TileSource'
import TileLayer from 'ol/layer/Tile'
import TileGrid from 'ol/tilegrid/TileGrid'

export class XYZ extends TileLayer {
  constructor(opts) {
    super(opts)
    let id = opts.id || `gx-${Math.random()}`
    this.set('id', id)
    this.id = id //backwards compatability with XMAP
    this.setSource(
      new XYZSource({
        projection: opts.projection || 'EPSG:3857',
        url: opts.url,
        crossOrigin: 'anonymous',
        attributions: opts.attribution || undefined,
        tileUrlFunction: opts.tileUrlFunction || undefined,
        tileGrid: opts.tileGrid ? new TileGrid(opts.tileGrid) : undefined,
      })
    )

    this.getSource().on('load-state', (e) => {
      this.dispatchEvent({
        type: 'layer-state',
        layer: this.id,
        state: e.state,
      })
    })
  }
}
